import { AcademicFeeDto } from './academicfeedto';
import { PaginationFeaturesDto } from './paginationfeaturesdto';

export class AcademicFeeRequest {

    academicFeeDto: AcademicFeeDto = new AcademicFeeDto();

    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}